// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1CompanySchema } from './v1/companySchema';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1ImportUpdateClientSchema } from './v1/import/updateClientSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const patchClientExternalReferencePathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
  id: z.number().int().describe("Timely client id"),
});

export const patchClientExternalReferenceHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Client external reference updated
 */
export const patchClientExternalReference200Schema = z.lazy(() => v1CompanySchema);

/**
 * @description Forbidden - Insufficient permissions
 */
export const patchClientExternalReference403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Client not found
 */
export const patchClientExternalReference404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Unprocessable Entity - Invalid external ID
 */
export const patchClientExternalReference422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const patchClientExternalReferenceMutationRequestSchema = z.lazy(() => v1ImportUpdateClientSchema);

export const patchClientExternalReferenceMutationResponseSchema = z.lazy(() => patchClientExternalReference200Schema);
